import { useEffect, useRef, useState } from 'react'
import s from './index.module.css'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getNextReport } from './helters/getNextReport';
import { isCourseAccessGranted } from '@/utils/isCourseAccessGranted/isCourseAccessGranted';
import { useGetId } from '@/hooks/useGetId';
import useRoles from '@/hooks/useRoles';
import { getLinkToMeeting } from '@/helpers/new/getLinkToMeeting';
import { LessonInfo } from './components/LessonInfo';
import { getCurrentReport } from './helters/getCurrentReport';
import { conferenceTypesEnum } from '@modals/Timetable/AddLessonOrMeeting/components/ConferenceType/conferenceTypesEnum';
import { timetableAPI, timetableBeta } from '@/api';
import { IsBbbUseInLessons } from '@pages/Admin/PlatformSettings2/ServiceIntegrations/components/BigBlueButtonIntegrationSettings/hooks/IsBbbUseInLessons';
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper';
import { useMeetingTimeRemaining } from '@modals/Timetable/ShowLessonOrMeeting/hooks/useMeetingTimeRemaining';
import { useCreateLonkToMeeting } from '@modals/Timetable/ShowLessonOrMeeting/hooks/useCreateLonkToMeeting';
import { isIOSDevice } from '@/helpers/new/isIOSDevice';
import useOpenLink from '@/hooks/useOpenLink';
import { useIsLimitTheTimeForEnteringLesson } from '@pages/Admin/PlatformSettings2/ScheduleClasses/hooks/useIsLimitTheTimeForEnteringLesson';
import { declOfNum } from '@/helpers/declOfNum';
import { useIsBbbCanBeUsedInSeparateLessons } from '@pages/Admin/PlatformSettings2/ServiceIntegrations/components/BigBlueButtonIntegrationSettings/hooks/useIsBbbCanBeUsedInSeparateLessons';
import { useGetPreparedMeetingLink } from '@modals/Timetable/ShowLessonOrMeeting/hooks/useGetPreparedMeetingLink';
import { shouldHideLessonLink } from '@/helpers/new/shouldHideLinkToCanceledLesson';
import { getMeetingIframeProvider } from '@common/MeetingIframe';
import { openMeetingIframe } from '@store/meetingIframeSlice';

const Further = ({type = 'next', reports, updateReports, isSeminarianView = false}) => {
  const dispatch = useDispatch();
  const { isLimit, timeLimit } = useIsLimitTheTimeForEnteringLesson();
  const isBbbUseInLessons = IsBbbUseInLessons();
  const isBbbCanBeUsedInSeparateLessons = useIsBbbCanBeUsedInSeparateLessons();
  // Ref для хранения интервала
  const intervalRef = useRef(null);
  const [lesson, setLesson] = useState(null);
  const childrenId = useGetId();
  const { isChildrenOrParent, isSeminarian, isSeniorSeminarian } = useRoles();
  const isSeminarianLessonMode = isSeminarian || isSeminarianView;
  const platformTime = useSelector(store => store.platformTime);
  const isTeacherArrivalTimeForTheMeetingStore = useSelector(store => store.settings?.isTeacherArrivalTimeForTheMeeting);
  const isTeacherArrivalTimeForTheMeeting = isTeacherArrivalTimeForTheMeetingStore === '1';
  const isSeparateLinksForStudentsAndTeachers = useSelector(store => store.settings.isSeparateLinksForStudentsAndTeachers);
  const isRemoveLinksToOfflineClasses = useSelector(store => store.settings.isRemoveLinksToOfflineClasses);
  const hideLinkToCanceledLesson = useSelector(store => store.settings.hideLinkToCanceledLesson);
  const isOpenTeleBossMeetingInIframe = useSelector(store => store.settings.isOpenTeleBossMeetingInIframe === '1');
  const isOpenImpulseVksMeetingInIframe = useSelector(store => store.settings.isOpenImpulseVksMeetingInIframe === '1');
  const { openLinkInNewTab, openLinkInSameTab } = useOpenLink()

  useEffect(()=>{
      if(platformTime?.status !== 'success') return;
      
      const getReport = type === 'current' ? getCurrentReport : getNextReport;
      const filteredReports = (reports ?? []).filter((report) => (
        !shouldHideLessonLink({
          report,
          isEnabled: hideLinkToCanceledLesson,
          isTeacherSide: isSeminarianLessonMode || isSeniorSeminarian,
        })
      ));

      setLesson(getReport(filteredReports, platformTime?.platformTime, !isBbbUseInLessons, isBbbCanBeUsedInSeparateLessons, isRemoveLinksToOfflineClasses))
  }, [
    reports,
    platformTime?.platformTime,
    platformTime?.status,
    isRemoveLinksToOfflineClasses,
    hideLinkToCanceledLesson,
    isSeminarian,
    isSeminarianLessonMode,
    isSeniorSeminarian,
    isBbbUseInLessons,
    isBbbCanBeUsedInSeparateLessons,
    type,
  ])
  
  const [accessStatus, setAccessStatus] = useState('error'); 
  // ставим error чтобы ничего не отображал компонент до загрузки accessStatus с сервера

  const setDenyAccess = async () => {
    if(!isChildrenOrParent || !lesson?.direction_id || !childrenId) return;
    try {
      const accessStatus = await isCourseAccessGranted({childrenId: childrenId, directionId: lesson?.direction_id, context: 'lessons'})
      setAccessStatus(accessStatus)
    }
    catch {
      setAccessStatus('error')
    }
  }

  useEffect(()=>{
    setDenyAccess()
  }, [isChildrenOrParent, lesson?.direction_id, childrenId])
  
  const goToMeeting = () => {
    if((!isSeminarianLessonMode) || (lesson?.opened_at) || !isTeacherArrivalTimeForTheMeeting || !lesson?.id) {
        return;
    }

    timetableAPI.saveTimeOpeningLessonFirstTime({id: lesson.id})
    .then(({data}) => {
        updateReports?.()
    })
  }

  const {
          isMeetingTimeActive,
          stopInterval
  } = useMeetingTimeRemaining({date_conference: lesson?.date_conference, start_time: lesson?.start_time});

  const {createLonkToMeeting, isCreatingLink} = useCreateLonkToMeeting();
  const createLinkAndGoToMeeting = async () => {
      const res = await createLonkToMeeting(
          {
              direction_id: lesson.direction_id ?? null,
              speaker_id: lesson?.speaker_id ?? null,
              report_id: lesson?.id
          }
      );

      if(res.status === 'sussess' && res.link) {
          setLesson((prev) => (
              {
                  ...prev,
                  link_to_meeting: res.link,
                  link_to_meeting_for_children: (isSeparateLinksForStudentsAndTeachers == '1' || isBbbUseInLessons || (isBbbCanBeUsedInSeparateLessons && lesson.lessonInBigBlueButton == 1)) ? res.linkForChildren : res.link
              }
          ))
          goToMeeting()
          if(isIOSDevice()){
              openLinkInSameTab(res.link)
          }
          else{
              openLinkInNewTab(res.link)
          }
          stopInterval()
      }
  }

  const getLesson = () => {
    if(lesson?.id){
      timetableBeta.getReport({id: lesson.id})
        .then(({data}) => {
            if(data.status === 'success'){
                setLesson(data?.data)
            }
        })
    }
  }
 
  const linkToMeeting = getLinkToMeeting({report: lesson});
  const shouldHideCurrentLessonLink = shouldHideLessonLink({
    report: lesson,
    isEnabled: hideLinkToCanceledLesson,
    isTeacherSide: isSeminarianLessonMode || isSeniorSeminarian,
  });
  const { preparedMeetingLink, loadingPreparedMeetingLink } = useGetPreparedMeetingLink({linkToMeeting, childrenId, reportId: lesson?.id})
  const meetingLink = preparedMeetingLink || linkToMeeting;
  const meetingIframeProvider = isChildrenOrParent
    ? getMeetingIframeProvider({
        meetingUrl: meetingLink,
        isTeleBossEnabled: isOpenTeleBossMeetingInIframe,
        isImpulseVksEnabled: isOpenImpulseVksMeetingInIframe,
      })
    : '';
  const shouldOpenMeetingInIframe = !!meetingIframeProvider;

  useEffect(() => {
      if (!!lesson?.id && (isBbbUseInLessons || (!!lesson?.lessonInBigBlueButton && isBbbCanBeUsedInSeparateLessons)) && !linkToMeeting) {
          // Запускаем интервал для проверки каждую минуту
          intervalRef.current = setInterval(() => {
              getLesson()
          }, 60000); // 60000 мс = 1 минута
          
          // Очищаем интервал при размонтировании компонента или изменении зависимостей
          return () => {
              if (intervalRef.current) {
                  clearInterval(intervalRef.current);
              }
          };
      }
  }, [lesson?.id, isBbbUseInLessons, isBbbCanBeUsedInSeparateLessons, lesson?.lessonInBigBlueButton, linkToMeeting]);

  if (loadingPreparedMeetingLink || !lesson || !lesson?.directionName || !lesson?.start_time || (accessStatus === 'error' && isChildrenOrParent && lesson?.conference_type !== conferenceTypesEnum.customizable)) return <></>
  if (shouldHideCurrentLessonLink) return <></>
  
  if(isChildrenOrParent && accessStatus === false){
    return(
      <Link to='/payment' className={s.courseTime}>
        <LessonInfo 
          current={type==='current'}
          direction={lesson?.directionName} 
          text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
          showLinkText={!!linkToMeeting}
        />
      </Link>
    )
  }

  if(!linkToMeeting && (isBbbUseInLessons || (!!lesson.lessonInBigBlueButton && isBbbCanBeUsedInSeparateLessons))) {
    if(!isSeminarianLessonMode){
      return (
          <TooltipWrapper title='Пожалуйста, подождите, ведущий встречи ещё не зашел на занятие' placement="bottom">
            <div className={s.courseTime}>
              <LessonInfo 
                current={type==='current'}
                direction={lesson?.directionName} 
                text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
              />
            </div>
          </TooltipWrapper>
      )
    }
    else{
      return(
        <TooltipWrapper title={!isMeetingTimeActive ? `Вы сможете перейти когда до занятия останется менее ${timeLimit} минут` : ''} placement="bottom">
          <button 
            onClick={
              () => {
                if(!isMeetingTimeActive || isCreatingLink) return;
                createLinkAndGoToMeeting()
              }
            }
            className={s.courseTime} >
            <LessonInfo 
              current={type==='current'}
              direction={lesson?.directionName} 
              text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
            />
          </button>
        </TooltipWrapper>
      )
    }
  }
  if(isLimit && !isMeetingTimeActive){
    return (
      <TooltipWrapper title={`Перейти на занятие можно будет за ${timeLimit} ${declOfNum(timeLimit, ['минута', 'минуты', 'минут'])} до его начала`} placement="bottom">
        <div className={s.courseTime}>
          <LessonInfo 
            current={type==='current'}
            direction={lesson?.directionName} 
            text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
            showLinkText={!!linkToMeeting}
          />
        </div>
      </TooltipWrapper>
    );
  }
  if(!linkToMeeting){
    return (
      <div className={s.courseTime}>
        <LessonInfo 
          current={type==='current'}
          direction={lesson?.directionName} 
          text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
        />
      </div>
    );
  }
  if (shouldOpenMeetingInIframe) {
    return (
      <>
        <button
          type="button"
          onClick={() => dispatch(openMeetingIframe({
            meetingUrl: meetingLink,
            provider: meetingIframeProvider,
          }))}
          className={`${s.courseTime} ${s.courseTimeButton}`}
        >
          <LessonInfo
            current={type==='current'}
            direction={lesson?.directionName}
            text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`}
            showLinkText={true}
          />
        </button>
      </>
    );
  }

  return (
    <a onClick={goToMeeting} href={meetingLink} target='_blank' rel="noreferrer" className={s.courseTime}>
      <LessonInfo
        current={type==='current'}
        direction={lesson?.directionName}
        text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`}
        showLinkText={true}
      />
    </a>
  );
}

export default Further
